import { MembershipLevel, CurrentPayPlan } from '@ace-clublabs/common-membership-api-types';
import { RoleType } from './IGetNewBusinessCost';
import { IPaperlessOptOut } from './INewJoinCache';

export enum GenderCode {
  M = 'M',
  F = 'F',
  X = 'X',
}

export const GENDER_CODE = {
  M: 'Male',
  F: 'Female',
  X: 'Nonbinary',
};

export interface IBaseCost {
  annual?: {
    baseCost: number;
    discountAmount: number;
  };
  monthly?: {
    baseCost: number;
    discountAmount: number;
  };
}

export interface ICost {
  baseCost: number;
  taxCost: number;
  discountAmount: number;
}

export interface IPayPlanCosts {
  primary: ICost;
  adult?: ICost;
  dependent?: ICost;
  associate?: ICost;
  familyUpgrade?: ICost;
  rv?: ICost;
  autoPay?: ICost;
  admissionFee?: ICost;
  membershipDiscounts?: IDiscount[];
}

export interface IMembershipLevelCost {
  annual?: IPayPlanCosts;
  monthly?: IPayPlanCosts | null;
}

export interface IRole {
  role: RoleType;
  typeDescription: string;
  maximumAllowed: number;
  minimumAge: number;
  maximumAge: number;
  isBirthDateRequired: boolean;
}

export interface IDiscount {
  rule: DiscountRule;
  count: number;
  displayCount: number;
  benefitLevel?: MembershipLevel;
}

export enum DiscountRule {
  FREE_ASSOCIATE = 'FREE_ASSOCIATE',
}

export interface IBenefit {
  infoVisible: string;
  topLevel: string;
  hideFromChart: string;
  benefitTitle: string;
  benefitSubTitle: string;
  benefitBody: string;
  infoModalId: string;
}

export interface INewMembershipInfo {
  allowedGenders: GenderCode[];
  allowedMembershipLevels: MembershipLevel[];
  allowedBillPlans: ('AC' | 'AH' | 'AM' | 'AD' | 'MP' | 'AX' | 'BA')[];
  membershipBaseCost: {
    CLASSIC?: IBaseCost;
    PLUS?: IBaseCost;
    PREMIER?: IBaseCost;
  };
  membershipCost: {
    CLASSIC?: IMembershipLevelCost;
    PLUS?: IMembershipLevelCost;
    PREMIER?: IMembershipLevelCost;
    fees: {
      sameDayServiceFee: number;
    };
  };
  membershipProducts: {
    RV: MembershipLevel[];
    ERS: MembershipLevel[];
  };
  roles: IRole[];
  benefits: {
    CLASSIC?: IBenefit[];
    PLUS?: IBenefit[];
    PREMIER?: IBenefit[];
    modalDetails: {
      [key: string]: {
        modalID: string;
        modalTitle: string;
        modalBody: string;
        modalFooter: string;
      };
    };
    disclaimers: {
      first: string;
      second: string;
      third: string;
      fourth: string;
    };
  };
  shortBenefits?: any;
  requestedMembershipLevel?: MembershipLevel;
  requestedBillPlan?: CurrentPayPlan;
  clubCode?: string;
  region?: string;
  defaultBillPlan: CurrentPayPlan;
  defaultMembershipLevel: MembershipLevel;
  campaignCode: string;
  paperlessOptOuts?: IPaperlessOptOut[];
  giftDetails?: {
    isHoliday?: boolean;
    giftCardValue?: number;
    maximumFutureDays?: number;
    maximumFutureDate?: string;
    seasons?: GiftSeason[];
    messages?: GiftMessage[];
  };
  insuranceLeadGeneration: {
    enabled: boolean;
    preselected: boolean;
  };
  enableDobField: boolean;
  enableMobileConsentSelection?: boolean;
}

export interface GiftSeason {
  type: GiftSeasonType;
  startDate: string;
  endDate: string;
}

export interface GiftMessage {
  type: GiftSeasonType | '';
  message: string;
  code: string;
}

export enum GiftSeasonType {
  HOLIDAY = 'HOLIDAY',
  NEW_YEARS = 'NEW_YEARS',
  VALENTINES = 'VALENTINES',
  MOTHERS_DAY = 'MOTHERS_DAY',
  FATHERS_DAY = 'FATHERS_DAY',
  EASTER = 'EASTER',
  THANKSGIVING = 'THANKSGIVING',
}
